import KunLoading84 from './src/index'

KunLoading84.install = function (Vue) {
	Vue.component(KunLoading84.name, KunLoading84);
}

export default KunLoading84;
